module.exports = __webpack_public_path__ + "static/media/menu_modelo_anamnese.b16b7dd7.png";